import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {FormsService} from '../shared/services/databaseServices/forms/forms.service';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {Form} from '../shared/classes/Form';
import {TranslatePipe} from '../translate.pipe';
import {RegisterFormService} from '../shared/services/registerFormService/register-form.service';
import {HttpParams} from '@angular/common/http';
import {PayService} from '../shared/services/payService/pay.service';
import {Token} from '../pay-method/Token';
import {CatTrackService} from '../shared/services/databaseServices/catTrackService/cat-track.service';
import {CatTrack} from '../shared/classes/CatTrack';
import {Track} from '../shared/classes/Track';

@Component({
  selector: 'app-show-form',
  templateUrl: './show-form.component.html',
  styleUrls: ['./show-form.component.css'],
  providers: [TranslatePipe]
})
export class ShowFormComponent implements OnInit {

  id;
  form: Form = undefined;
  catTrack: CatTrack[] = [];
  filteredTrack: Track[] = [];
  now = new Date().getTime();

  year = new Date().getFullYear();

  public regForm = this.formBuilder.group({
    name: ['', [Validators.required]],
    surname: ['', [Validators.required]],
    email: ['', [Validators.required, Validators.email]],
    mobile: ['', [Validators.pattern('^\\+[0-9]{1,4} [0-9]{3,14}$')]],
    sex: ['', [Validators.required]],
    club: ['', []],
    team: ['', []],
    category: ['', [Validators.required]],
    year: ['', [Validators.min(1900)]],
    city: ['', []],
    country: ['', []],
    tshirt: [false, []],
    tshirtSize: ['', []],
    acomodation: [false, []],
    familyTandem: [false, []],
    eat: [false, []],
    contactPerson: ['', []],
    voucher: ['', []],
    note: ['', []],
    track: ['', []],
    lunch: ['', []],
    rules: [false, [Validators.required]],
    media: [false, [Validators.required]],
    gdpr: [false, [Validators.requiredTrue]],
    newsletter: [false, []],
  });

  constructor(private activatedRoute: ActivatedRoute,
              private formsService: FormsService,
              private translate: TranslatePipe,
              private formBuilder: FormBuilder,
              private registerFormService: RegisterFormService,
              private payService: PayService,
              private catTrackService: CatTrackService,
              private router: Router) { }

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.payService.returnFormId = this.id;

    let url = location.search;

    const query = url.substr(1);
    let result = {};
    if(url.length > 0) {
      query.split('&').forEach(part => {
        const item = part.split('=');
        result[item[0]] = decodeURIComponent(item[1]);
      });
    } else {
      result = undefined;
    }

    if (result !== undefined) {
      // @ts-ignore
      const payId = result.id;

      this.payService.getToken().then(data => {
        const token: Token = data as Token;

        this.payService.getStateOfPay(token, payId).then(dataStatus => {
        });

      });
    }

    this.formsService.getOneForm(this.id).then( data => {
      console.dir(data.data());
      this.form = new Form();
      this.form.url = data.data().url;
      this.form.formItems = data.data().formItems;
      this.form.payMethod = data.data().payMethod;
      this.form.key = data.id;
      data.data().race.get().then( race => {
        this.form.race = race.data();
        console.dir(this.form.race);

        // this.form.race.track.forEach(item => {
        //   this.regForm.addControl(item.track, new FormControl(false, []));
        // });

        this.catTrackService.readOne(race.id).then(data => {
          for (const c in data.data()) {
            this.catTrack.push(data.data()[c]);
          }
          if(this.registerFormService.regForm){
            this.fillForm();
            this.filterTrack();
            this.regForm.patchValue({track: this.registerFormService.regForm.track});
            this.registerFormService.regForm = undefined;
          }
        });
      });

      this.form.formItems.forEach(item => {
        if(item.required) {
          this.regForm.get(item.key).setValidators(Validators.required);
        }
      });

    });


  }

  fillForm(){
    this.regForm.patchValue({
      name: this.registerFormService.regForm.name,
      surname: this.registerFormService.regForm.surname,
      email: this.registerFormService.regForm.email,
      mobile: this.registerFormService.regForm.mobile,
      sex: this.registerFormService.regForm.sex,
      club: this.registerFormService.regForm.club,
      team: this.registerFormService.regForm.team,
      category: this.registerFormService.regForm.category,
      year: this.registerFormService.regForm.year,
      city: this.registerFormService.regForm.city,
      familyTandem: this.registerFormService.regForm.familyTandem,
      country: this.registerFormService.regForm.country,
      tshirt: this.registerFormService.regForm.tshirt,
      tshirtSize: this.registerFormService.regForm.tshirtSize,
      acomodation: this.registerFormService.regForm.acomodation,
      eat: this.registerFormService.regForm.eat,
      contactPerson: this.registerFormService.regForm.contactPerson,
      voucher: this.registerFormService.regForm.voucher,
      note: this.registerFormService.regForm.note,
      lunch: this.registerFormService.regForm.lunch,
      gdpr: this.registerFormService.regForm.gdpr,
      newsletter: this.registerFormService.regForm.newsletter,
      media: this.registerFormService.regForm.media
    });
  }

  openGdpr() {
    localStorage.setItem("gdpr", this.form.race.gdprPlaceholder);
    const url = this.router.serializeUrl(
      this.router.createUrlTree([`/gdpr/data`])
    );
    window.open(url, '_blank');
  }

  filterTrack() {
    const catName = this.regForm.getRawValue().category;
    if(!catName) {
      return [];
    };
    const tracks: Track[] = [];

    this.catTrack.forEach( t => {
      if (t.cat.filter( c => c.name === catName && c.available ).length > 0) {
        tracks.push(t.track);
      }
    });
    this.filteredTrack = tracks;
  }

  login() {
    console.dir(this.regForm);

    this.registerFormService.form = this.form;
    this.registerFormService.regForm = this.regForm.getRawValue();

    this.form.race.track.forEach(item => {
      if(this.regForm.getRawValue()[item.track]){
        console.dir(item.track);
        this.registerFormService.regForm.track = this.registerFormService.regForm.track + item.track + " ";
      }
    });
    localStorage.removeItem("gdpr");
    this.router.navigate(['/recapForm']);
  }

  showItem(itemName) {
    return this.form.formItems.filter(item => item.key === itemName)[0].visible;
  }

  isRequired(itemName) {
    return this.form.formItems.filter(item => item.key === itemName)[0].required;
  }

  getEnum(itemName): any[] {
    return this.form.formItems.filter(item => item.key === itemName)[0].enum;
  }

  getLunch() {
    return ['MASOVÉ nepálivé bezlepkové RED KARI s rýží', 'VEGAN nepálivé bezlepkové RED KARI s rýží']
  }

  getTranslation(item): string {
    return this.translate.transform(`settingPage.formBuilder.formBuilder.item.${item}`);
  }

}
